import { EnumActions } from "../actions";

const initialState = {
  enums: {},
  loading: false,
};

export default function enumReducer(state = initialState, action) {
  switch (action.type) {
    case EnumActions.ACTION_SAVE_ENUM:
      // eslint-disable-next-line no-case-declarations
      const { enumName, data } = action.payload;
      return {
        ...state,
        enums: {
          ...state.enums,
          [enumName]: data,
        },
      };

    case EnumActions.ACTION_CLEAR_ENUM_CACHE:
      return {
        ...state,
        enums: {},
      };

    default:
      return state;
  }
}

export const getEnum = (state, enumName) => {
  return state.enum?.enums?.[enumName] || null;
};

export const getMultipleEnums = (state, enumNames) => {
  return enumNames.reduce((acc, enumName) => {
    acc[enumName] = state.enum?.enums?.[enumName] || null;
    return acc;
  }, {});
};

export const isEnumLoaded = (state, enumName) => {
  return state.enum?.enums?.[enumName] != null;
};

export const getAllEnums = state => {
  return state.enum?.enums || {};
};

export const getEnumLoading = state => {
  return state.enum?.loading || false;
};

export const EnumSelectors = {
  getEnum,
  getMultipleEnums,
  isEnumLoaded,
  getAllEnums,
  getEnumLoading,
};
